"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledInput = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _colorUtils = require("../../../../utils/color-utils");
var _palette = require("../../../../styles/palette");
var _fieldStyledComponents = require("../../../../styles/styled-components/field-styled-components");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
//helpers

//styled-components

var StyledInput = exports.StyledInput = _styledComponents["default"].input.withConfig({
  displayName: "styles__StyledInput",
  componentId: "sc-9su2lz-0"
})(["background:none;border-color:", ";border-style:solid;border-width:0 0 1px;color:", ";display:block;font:inherit;max-width:100%;outline:0;padding:0;&:invalid{border-color:", ";}&::placeholder{color:", ";}+ ", "{height:20px;margin:0;padding-top:4px;white-space:nowrap;}"], (0, _colorUtils.transparentize)(_palette.commonPalette.btnGreen, 0.5), _palette.commonPalette.txboxValue, (0, _colorUtils.transparentize)(_palette.commonPalette.red, 0.5), _palette.commonPalette.txboxPlaceholder, function () {
  return _fieldStyledComponents.Error;
});
//# sourceMappingURL=styles.js.map